export default class RecordHandlerWeb {
    constructor() {
        this.needAdjustTools = ["insert_picture"];

        this.typeMap = new Map();
        this.typeMap.set("insert_picture", "Image");
    }

    async adjustRecord(data, recordPath) {
        let userPaint = await this.checkImgExists(data.userPaint, recordPath);
        let graphicPaint = await this.checkImgExists(data.graphicPaint, recordPath);
        data.userPaint = userPaint;
        data.graphicPaint = graphicPaint;

        return JSON.stringify(data);
    }

    async checkImgExists(record, recordPath) {
        let userPaint = [];
        for (let i = 0; i < record.length; i++) {
            const pageRecord = JSON.parse(record[i].save);

            for (let j = 0; j < pageRecord.objects.length; j++) {
                if (this.needAdjustTools.includes(pageRecord.objects[j].toolType)) {
                    const src = recordPath + pageRecord.objects[j].imageFileName
                    console.log(src, " file not exists");
                    // pageRecord.objects[j].type = "Group";
                    pageRecord.objects[j].src = src;
                }
            }

            let json_string = {
                key: record[i].key,
                save: JSON.stringify(pageRecord)
            }
            userPaint.push(json_string);
        }

        return userPaint;
    }
}